export const IMAGE_CONSTANTS = {
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_TYPES: ['image/jpeg', 'image/png', 'image/webp'],
  RECOMMENDED_DIMENSIONS: {
    width: 390,
    height: 844
  },
  ACCEPTED_EXTENSIONS: '.jpg,.jpeg,.png,.webp'
};

export const EVENT_CONSTANTS = {
  MAX_TITLE_LENGTH: 100,
  MAX_LOCATION_LENGTH: 250,
  MIN_TITLE_LENGTH: 1,
  MIN_LOCATION_LENGTH: 1
};

export const UPLOAD_STATUS = {
  IDLE: 'idle',
  UPLOADING: 'uploading',
  SUCCESS: 'success',
  ERROR: 'error',
  RETRY: 'retry'
};

export const ERROR_MESSAGES = {
  NO_FILE: 'Por favor selecciona una imagen',
  INVALID_TYPE: 'Formato no permitido. Use JPEG, PNG o WebP',
  FILE_TOO_LARGE: 'La imagen es demasiado grande. Máximo 5MB',
  UPLOAD_FAILED: 'Error al subir la imagen. Inténtalo nuevamente',
  NETWORK_ERROR: 'Error de conexión. Verifica tu internet',
  DUPLICATE_IMAGE: 'Esta imagen ya ha sido subida anteriormente',
  REQUIRED_FIELDS: 'Por favor completa todos los campos requeridos',
  INVALID_DATES: 'La fecha de fin debe ser posterior a la fecha de inicio'
};

export const SUCCESS_MESSAGES = {
  IMAGE_UPLOADED: 'Imagen subida exitosamente',
  EVENT_CREATED: 'Evento creado exitosamente',
  EVENT_UPDATED: 'Evento actualizado exitosamente',
  EVENT_DELETED: 'Evento eliminado exitosamente'
};

export const VALIDATION_PATTERNS = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^\+?[\d\s\-()]+$/,
  ALPHANUMERIC: /^[a-zA-Z0-9\sáéíóúÁÉÍÓÚñÑüÜ\-_.,()]+$/
};